import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Spinner } from '@instructure/ui-spinner';
import { View } from '@instructure/ui-view';
import { AddContentModal, AddContentPopover, QuizInstructions, QuizTitle } from '@instructure/quiz-core';
import { QUIZ_ENTRY_REF, INSTRUCTIONS_SCROLL_KEY, TITLE_SCROLL_KEY } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import QuizEntriesSection from '../QuizEntriesSection';
import { QuizGenerationModal, quizGenerationRegionType } from '../QuizGenerationModal';
import { extractPointsPossible } from './extractPointsPossible';
export var buildContentSlotPropsType = PropTypes.shape({
  quizGeneration: PropTypes.shape({
    region: quizGenerationRegionType,
    enabled: PropTypes.bool,
    getJWT: PropTypes.func,
    loadRemoteModule: PropTypes.func,
    onSubmit: PropTypes.func
  })
});
export var BuildContent = /*#__PURE__*/function (_Component) {
  function BuildContent() {
    var _this2;
    _classCallCheck(this, BuildContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BuildContent, [].concat(args));
    _defineProperty(_this2, "state", {
      quizGenerationModalOpen: false,
      modalPosition: null,
      modalActivityState: 'idle'
    });
    _defineProperty(_this2, "quizId", function () {
      return _this2.props.quiz.id;
    });
    _defineProperty(_this2, "quizEntryRef", function (quizEntryId) {
      return function (node) {
        _this2["".concat(QUIZ_ENTRY_REF, "_").concat(quizEntryId)] = node;
      };
    });
    _defineProperty(_this2, "quizEntryWrapperRef", function (quizEntryId) {
      return function (node) {
        _this2["".concat(QUIZ_ENTRY_REF, "_").concat(quizEntryId)] = node;
      };
    });
    _defineProperty(_this2, "handleOpenQuizGenerationModal", function (position) {
      _this2.setState({
        quizGenerationModalOpen: true,
        modalPosition: position
      });
    });
    _defineProperty(_this2, "handleDismissQuizGenerationModal", function () {
      _this2.setState({
        quizGenerationModalOpen: false,
        modalPosition: null
      });
    });
    _defineProperty(_this2, "handleModalStateChange", function (modalActivityState) {
      _this2.setState({
        modalActivityState: modalActivityState
      });
    });
    _defineProperty(_this2, "renderAddContentPopover", function (modalActivityState) {
      return function (isOver, position) {
        var _slotProps$quizGenera;
        var _this2$props = _this2.props,
          quiz = _this2$props.quiz,
          lockBlueprintContentEnabled = _this2$props.lockBlueprintContentEnabled,
          slotProps = _this2$props.slotProps;
        var isQuizContentLocked = quiz.originalQuizLockedByBlueprint && lockBlueprintContentEnabled;
        var shouldRenderAddContentPopover = !(isOver || isQuizContentLocked);
        if (!shouldRenderAddContentPopover) {
          return null;
        }
        return /*#__PURE__*/React.createElement(AddContentPopover, {
          quizId: _this2.quizId(),
          position: position,
          slotProps: {
            quizGenerationButton: {
              onClick: function onClick() {
                return _this2.handleOpenQuizGenerationModal(position);
              },
              visible: modalActivityState !== 'error' && (slotProps === null || slotProps === void 0 || (_slotProps$quizGenera = slotProps.quizGeneration) === null || _slotProps$quizGenera === void 0 ? void 0 : _slotProps$quizGenera.enabled),
              disabled: modalActivityState !== 'success'
            }
          }
        });
      };
    });
    _defineProperty(_this2, "storeStartQuizEntries", function (node) {
      _this2.startQuizEntries = node;
    });
    _defineProperty(_this2, "storeEndQuizEntries", function (node) {
      _this2.endQuizEntries = node;
    });
    _defineProperty(_this2, "handleQuizGenerationSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _slotProps$quizGenera2, _slotProps$quizGenera3;
        var generatedItems, _this2$props2, createBulkItems, createBulkQuizEntries, addSuccessAlert, addInfoAlert, slotProps, modalPosition, _yield$createBulkItem, items, errors;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              generatedItems = _ref.data;
              _this2$props2 = _this2.props, createBulkItems = _this2$props2.createBulkItems, createBulkQuizEntries = _this2$props2.createBulkQuizEntries, addSuccessAlert = _this2$props2.addSuccessAlert, addInfoAlert = _this2$props2.addInfoAlert, slotProps = _this2$props2.slotProps;
              modalPosition = _this2.state.modalPosition;
              if (!(modalPosition == null)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return createBulkItems(generatedItems, {
                parentId: _this2.quizId(),
                parentType: 'quizzes'
              });
            case 7:
              _yield$createBulkItem = _context.sent;
              items = _yield$createBulkItem.items;
              errors = _yield$createBulkItem.errors;
              _context.next = 12;
              return createBulkQuizEntries(items, {
                quizId: _this2.quizId(),
                startPosition: modalPosition,
                pointsPossible: extractPointsPossible(generatedItems)
              });
            case 12:
              if (errors && errors.length > 0) {
                addInfoAlert(t('There was a problem saving some quiz entries, but others were saved successfully.'));
              } else {
                addSuccessAlert(t('Quiz entries created successfully.'));
              }
              _this2.handleDismissQuizGenerationModal();
              slotProps === null || slotProps === void 0 || (_slotProps$quizGenera2 = slotProps.quizGeneration) === null || _slotProps$quizGenera2 === void 0 || (_slotProps$quizGenera3 = _slotProps$quizGenera2.onSubmit) === null || _slotProps$quizGenera3 === void 0 || _slotProps$quizGenera3.call(_slotProps$quizGenera2, generatedItems);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this2;
  }
  _inherits(BuildContent, _Component);
  return _createClass(BuildContent, [{
    key: "render",
    value: function render() {
      var _this3 = this,
        _this$props$slotProps,
        _this$props$slotProps2,
        _this$props$slotProps3,
        _this$state,
        _this$props$slotProps4,
        _this$props$slotProps5;
      return this.props.connectDropTarget(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuizTitle, {
        onQuizUpdated: this.props.onQuizUpdated,
        quiz: this.props.quiz,
        workingQuiz: this.props.workingQuiz,
        scrollKey: TITLE_SCROLL_KEY
      }), /*#__PURE__*/React.createElement(QuizInstructions
      // to help with DnD above first quizEntry:
      , {
        ref: this.storeStartQuizEntries,
        quiz: this.props.quiz,
        scrollKey: INSTRUCTIONS_SCROLL_KEY
      }), /*#__PURE__*/React.createElement(AddContentModal, {
        slotProps: {
          quizGenerationButton: {
            onClick: function onClick(position) {
              return _this3.handleOpenQuizGenerationModal(position);
            },
            visible: this.state.modalActivityState !== 'error' && ((_this$props$slotProps = this.props.slotProps) === null || _this$props$slotProps === void 0 || (_this$props$slotProps = _this$props$slotProps.quizGeneration) === null || _this$props$slotProps === void 0 ? void 0 : _this$props$slotProps.enabled),
            disabled: this.state.modalActivityState !== 'success'
          }
        }
      }), ((_this$props$slotProps2 = this.props.slotProps) === null || _this$props$slotProps2 === void 0 || (_this$props$slotProps2 = _this$props$slotProps2.quizGeneration) === null || _this$props$slotProps2 === void 0 ? void 0 : _this$props$slotProps2.enabled) && /*#__PURE__*/React.createElement(QuizGenerationModal, {
        onModalStateChange: this.handleModalStateChange,
        loadRemoteModule: (_this$props$slotProps3 = this.props.slotProps) === null || _this$props$slotProps3 === void 0 ? void 0 : _this$props$slotProps3.quizGeneration.loadRemoteModule,
        modalConfig: {
          open: ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.quizGenerationModalOpen) || false,
          region: (_this$props$slotProps4 = this.props.slotProps) === null || _this$props$slotProps4 === void 0 ? void 0 : _this$props$slotProps4.quizGeneration.region,
          getJWT: (_this$props$slotProps5 = this.props.slotProps) === null || _this$props$slotProps5 === void 0 ? void 0 : _this$props$slotProps5.quizGeneration.getJWT,
          onSubmit: this.handleQuizGenerationSubmit,
          onDismiss: this.handleDismissQuizGenerationModal
        }
      }), this.renderAddContentPopover(this.state.modalActivityState)(this.props.isOver, 0), !this.props.quizEntriesLoaded ? /*#__PURE__*/React.createElement(View, {
        as: "div",
        padding: "large",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading')
      })) : /*#__PURE__*/React.createElement(QuizEntriesSection, {
        isOver: this.props.isOver,
        quizId: this.props.quiz.id,
        isContentLockedByBlueprint: this.props.isContentLockedByBlueprint,
        quizEntries: this.props.quizEntries,
        renderAddContentPopover: this.renderAddContentPopover(this.state.modalActivityState),
        setQuizEntryRef: this.quizEntryRef,
        setQuizEntryWrapperRef: this.quizEntryWrapperRef,
        separatorConfig: this.props.separatorConfig
      }), /*#__PURE__*/React.createElement("div", {
        ref: this.storeEndQuizEntries
      })));
    }
  }]);
}(Component);
_defineProperty(BuildContent, "propTypes", {
  connectDropTarget: PropTypes.func.isRequired,
  // injected by DnD
  isOver: PropTypes.bool,
  // injected by DnD
  lockBlueprintContentEnabled: PropTypes.bool.isRequired,
  onQuizUpdated: PropTypes.func,
  // passed in by consumer, optional
  quiz: ImmutablePropTypes.record.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntriesLoaded: PropTypes.bool.isRequired,
  workingQuiz: ImmutablePropTypes.record.isRequired,
  isContentLockedByBlueprint: PropTypes.bool.isRequired,
  separatorConfig: PropTypes.shape({
    decimalSeparator: PropTypes.string,
    thousandSeparator: PropTypes.string
  }),
  addSuccessAlert: PropTypes.func.isRequired,
  addInfoAlert: PropTypes.func.isRequired,
  createBulkItems: PropTypes.func.isRequired,
  createBulkQuizEntries: PropTypes.func.isRequired,
  slotProps: buildContentSlotPropsType
});
_defineProperty(BuildContent, "defaultProps", {
  isOver: false,
  isContentLockedByBlueprint: false,
  lockBlueprintContentEnabled: false,
  onQuizUpdated: function onQuizUpdated() {}
});